(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ch-product-card__img:not(.ch-product-card__img--secondary)').forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) {
        img.classList.add('ch-loaded');
        var wrap = img.closest('.ch-product-card__img-wrap');
        if (wrap) wrap.classList.add('ch-loaded');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ch-theme-toggle"] && !Shopify.designMode) return;
  try {
    (function() {
    var btn = document.getElementById('ch-theme-toggle');
    if (!btn) return;
    btn.addEventListener('click', function() {
      var isDark = document.documentElement.classList.toggle('dark');
      localStorage.setItem('color-theme', isDark ? 'dark' : 'light');
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    (function () {
    var wrapper = document.querySelector('.mobile-facets__wrapper');
    if (!wrapper) return;

    var sectionGroup = wrapper.closest('.shopify-section-group');
    if (!sectionGroup) return;

    var observer = new MutationObserver(function () {
      if (wrapper.classList.contains('menu-opening')) {
        sectionGroup.style.setProperty('z-index', '5', 'important');
      } else {
        sectionGroup.style.removeProperty('z-index');
      }
    });

    observer.observe(wrapper, { attributes: true, attributeFilter: ['class'] });
  })();
  } catch(e) { console.error(e); }
})();

})();
